import { Discount } from '../models/discount.model'
import { BookPriceOffer } from '../models/vouchers/book_price_offer.model'
import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Product } from '../models/product.model';
import { TranslateService } from '@ngx-translate/core';
import { CurrencyPrice } from '../models/currency_price.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BookLaunchOffer } from '../models/book_launch_offer.model';

import bookLaunchOfferQuery from 'src/app/graphql/queries/book_launch_offer.query.graphql'

@Injectable()
export class BookLaunchOfferService extends GraphQLService<BookLaunchOffer> {
  constructor(
    http: HttpClient,
    snackBar: MatSnackBar,
    private translate: TranslateService
  ) {
    super(http, snackBar);
    /* DO NOT DELETE */
    new Product()
    new BookPriceOffer()
    new CurrencyPrice()
    /* DO NOT DELETE END */
  }

  byCode(token: string) {
    return this.find(bookLaunchOfferQuery, {token: token})
  }

}
